// extracted by mini-css-extract-plugin
export default {"basicBtn":"index_basicBtn__KgB-g","wrapper":"index_wrapper__keSjX","confirmBtn":"index_confirmBtn__HSkkg","message":"index_message__UGZVG","canceLBtn":"index_canceLBtn__22lwX"};